import { ListItemIcon, MenuItem, Select } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { changeLanguage } from 'src/redux/features/auth/slice';
import { UPDATE_USER } from 'src/apiService/apiDeclaration';
const LanguageSelector = ({ isDark = false }) => {
  const dispatch = useDispatch();
  const { user, language } = useSelector((state) => state.auth);
  const onLanguageChange = async (event) => {
    dispatch(changeLanguage(event.target.value));
    if (user) {
      await UPDATE_USER(user._id, { language: event.target.value });
    }
  };

  return (
    <Select
      value={language}
      size="small"
      sx={{
        width: 'maxContent',
        height: '33px',
        borderColor: 'red',
        '& .MuiSelect-select': { color: isDark ? 'white' : '' },
      }}
      onChange={onLanguageChange}
    >
      <MenuItem value={'FRENCH'}>
        <ListItemIcon>Français</ListItemIcon>
      </MenuItem>
      <MenuItem value={'ENGLISH'}>
        <ListItemIcon>English</ListItemIcon>
      </MenuItem>
    </Select>
  );
};

export default LanguageSelector;
